import { Form, Input } from "antd";
import React from "react";
import { tracheostomyTubeOptions } from "../../Options/RespiratoryTherapistOptions";
import DeselectableRadioGroup from "../../../../blocks/FormItems/DeselectableRadioGroup";

const TracheostomyTube = ({ form }) => {
  return (
    <>
      <DeselectableRadioGroup
        label={"Tracheostomy Tube"}
        name={["tracheostomy_tube", "status"]}
        options={tracheostomyTubeOptions}
        form={form}
      />
      <Form.Item name={["tracheostomy_tube", "comments"]}>
        <Input placeholder="Comments" />
      </Form.Item>
    </>
  );
};

export default TracheostomyTube;
